import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { ICampaign, GenericResponse, IAccount, IBusiness, IInstallation, IPaginated, TypeContract } from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewOfferService {
  constructor(private http: HttpClient, private config: ConfigService) { }

  public getAccounts(): Observable<GenericResponse<IPaginated<IAccount>>> {
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getAccounts'));
  }

  public getTypeContract(): Observable<GenericResponse<TypeContract>> {
    return this.http.get<GenericResponse<TypeContract>>(this.config.getUrl('maestros.getTypeContract'));
  }

  public getBusiness(params: any): Observable<GenericResponse<IPaginated<IBusiness>>> {
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getBusinesses'), { params });
  }

  public getInstallations(params: any): Observable<GenericResponse<IPaginated<IInstallation>>> {
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getInstallations'), { params });
  }

  public getCampaigns(params: any): Observable<GenericResponse<ICampaign[]>> {
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getCampaigns'), { params });
  }

  public getDocument(CodigoCRMOferta: string[]): Observable<any> {
    return this.http.get(this.config.getUrl('grandesCuentas.offers.getFile'), {
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
      params: { CodigoCRMOferta }
    });
  }

  public setOffer(body: any): Observable<any> {
    return this.http.post<GenericResponse>(this.config.getUrl('grandesCuentas.offers.setOffer'), body);
  }
}
